// Product Gallery Module — single sliding strip, no stacking, no flash
(function () {
  const enableAutoplay =
    typeof window.enableAutoplay !== "undefined" ? window.enableAutoplay : false;

  // Strip + image CSS lives in shop-product-details.css

  class ProductGallery {
    constructor(container) {
      this.container   = container;
      this.mainImages  = Array.from(container.querySelectorAll(".shop-main-image"));
      this.thumbnails  = Array.from(container.querySelectorAll(".shop-thumbnail"));
      this.prevArrow   = container.querySelector(".shop-prev-arrow");
      this.nextArrow   = container.querySelector(".shop-next-arrow");
      this.indicators  = container.querySelector(".shop-indicators, #thumbnail-indicators");
      this.currentIndex = 0;
      this.maxIndex     = this.mainImages.length - 1;
      this.animating    = false;

      this.drag = {
        active: false, startX: 0, startY: 0,
        currentX: 0,   axis: null,
        threshold: 6,  swipe: 45,
      };

      this.init();
    }

    // ── Build the strip ───────────────────────────────────────────────────
    init() {
      const imgContainer = this.container.querySelector(".shop-image-container");
      if (!imgContainer) return;

      // Create the strip div and move all images into it
      this.strip = document.createElement("div");
      this.strip.className = "pg-strip";
      this.mainImages.forEach(img => {
        // Remove any inline display:none / display:block from Liquid
        img.style.cssText = "";
        this.strip.appendChild(img);
      });
      imgContainer.appendChild(this.strip);

      // Snap to index 0 with no transition
      this._setPosition(0, false);

      this.thumbnails.forEach((t, i) => t.classList.toggle("active", i === 0));
      this._updateUi(0);
      this.createIndicators();
      this.attachEvents();
      this.handleVideoAutoplay(0);
    }

    // Move strip to a given index — with or without CSS transition
    _setPosition(index, animate) {
      const pct = index * -100;
      if (animate) {
        this.strip.style.transition = "transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)";
      } else {
        this.strip.style.transition = "none";
      }
      this.strip.style.transform = `translateX(${pct}%)`;
    }

    // ── Events ────────────────────────────────────────────────────────────
    attachEvents() {
      this.thumbnails.forEach((t, i) =>
        t.addEventListener("click", () => this.changeImage(i))
      );
      if (this.prevArrow)
        this.prevArrow.addEventListener("click", () =>
          this.changeImage(this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1)
        );
      if (this.nextArrow)
        this.nextArrow.addEventListener("click", () =>
          this.changeImage(this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1)
        );
      if (this.indicators)
        this.indicators.addEventListener("click", e => {
          if (e.target.classList.contains("shop-indicator-dot")) {
            const i = parseInt(e.target.getAttribute("data-index"));
            if (!isNaN(i)) this.changeImage(i);
          }
        });

      const area = this.container.querySelector(".shop-main-image-wrapper");
      if (!area) return;

      // Touch
      area.addEventListener("touchstart",  e => this._ds(e), { passive: true });
      area.addEventListener("touchmove",   e => this._dm(e), { passive: false });
      area.addEventListener("touchend",    e => this._de(e), { passive: true });
      area.addEventListener("touchcancel", e => this._dc(),  { passive: true });

      // Mouse
      area.addEventListener("mousedown",  e => { if (e.button !== 0) return; e.preventDefault(); this._ds(e); });
      window.addEventListener("mousemove", e => this._dm(e));
      window.addEventListener("mouseup",   e => this._de(e));
      area.addEventListener("dragstart",   e => e.preventDefault());
    }

    _cx(e) { return e.touches ? e.touches[0].clientX : e.clientX; }
    _cy(e) { return e.touches ? e.touches[0].clientY : e.clientY; }

    _ds(e) {
      if (this.animating) return;
      this.drag.active   = true;
      this.drag.startX   = this._cx(e);
      this.drag.startY   = this._cy(e);
      this.drag.currentX = this._cx(e);
      this.drag.axis     = null;
      // Kill transition while dragging so the strip follows the finger exactly
      this.strip.style.transition = "none";
      // Prevent text selection and show grab cursor during drag
      document.body.style.userSelect    = "none";
      document.body.style.webkitUserSelect = "none";
      if (this.strip.parentElement)
        this.strip.parentElement.style.cursor = "grabbing";
    }

    _dm(e) {
      if (!this.drag.active) return;
      const dx = this._cx(e) - this.drag.startX;
      const dy = this._cy(e) - this.drag.startY;

      if (!this.drag.axis) {
        if (Math.abs(dx) < this.drag.threshold && Math.abs(dy) < this.drag.threshold) return;
        this.drag.axis = Math.abs(dx) >= Math.abs(dy) ? "x" : "y";
      }
      if (this.drag.axis !== "x") return;
      if (e.cancelable) e.preventDefault();

      this.drag.currentX = this._cx(e);

      // Translate the strip: base position + live finger delta
      // Using pixels so it feels 1:1 with the finger
      const containerW   = this.strip.parentElement.offsetWidth;
      const baseOffset   = this.currentIndex * -containerW;
      const pxOffset     = baseOffset + dx;
      // Convert to percentage of one slide width for the transform
      const pct = (pxOffset / containerW) * 100;
      this.strip.style.transform = `translateX(${pct}%)`;
    }

    _de(e) {
      if (!this.drag.active) return;
      this.drag.active = false;
      // Restore selection and cursor
      document.body.style.userSelect    = "";
      document.body.style.webkitUserSelect = "";
      if (this.strip.parentElement)
        this.strip.parentElement.style.cursor = "";
      if (this.drag.axis !== "x") { this.drag.axis = null; return; }
      this.drag.axis = null;

      const dx = this.drag.currentX - this.drag.startX;

      if (Math.abs(dx) >= this.drag.swipe) {
        if (dx < 0 && this.currentIndex < this.maxIndex) {
          this.changeImage(this.currentIndex + 1);
        } else if (dx > 0 && this.currentIndex > 0) {
          this.changeImage(this.currentIndex - 1);
        } else {
          // Edge — snap back with spring
          this._setPosition(this.currentIndex, true);
        }
      } else {
        // Not enough travel — spring back
        this._setPosition(this.currentIndex, true);
      }
    }

    _dc() {
      if (!this.drag.active) return;
      this.drag.active = false;
      this.drag.axis   = null;
      document.body.style.userSelect    = "";
      document.body.style.webkitUserSelect = "";
      if (this.strip.parentElement)
        this.strip.parentElement.style.cursor = "";
      this._setPosition(this.currentIndex, true);
    }

    // ── Public changeImage ────────────────────────────────────────────────
    changeImage(index) {
      if (index < 0 || index > this.maxIndex) return;
      if (index === this.currentIndex && !this.animating) return;
      if (this.animating) return;

      this.animating = true;
      this._setPosition(index, true);
      this._updateUi(index);

      // After transition ends, update state
      const onDone = () => {
        this.strip.removeEventListener("transitionend", onDone);
        this.currentIndex = index;
        this.animating    = false;
        this.scrollToThumbnail(index);
        this.handleVideoAutoplay(index);
      };
      this.strip.addEventListener("transitionend", onDone, { once: true });

      // Safety fallback in case transitionend doesn't fire
      setTimeout(() => {
        if (this.animating) {
          this.currentIndex = index;
          this.animating    = false;
        }
      }, 450);
    }

    // ── Helpers ───────────────────────────────────────────────────────────
    _updateUi(index) {
      this.thumbnails.forEach((t, i) => t.classList.toggle("active", i === index));
      if (this.indicators)
        Array.from(this.indicators.children).forEach((d, i) =>
          d.classList.toggle("active", i === index)
        );
      if (this.prevArrow) this.prevArrow.classList.toggle("disabled", index === 0);
      if (this.nextArrow) this.nextArrow.classList.toggle("disabled", index === this.maxIndex);
    }

    createIndicators() {
      if (!this.indicators) return;
      this.indicators.innerHTML = "";
      this.mainImages.forEach((_, i) => {
        const d = document.createElement("div");
        d.className = "shop-indicator-dot" + (i === 0 ? " active" : "");
        d.setAttribute("data-index", i);
        this.indicators.appendChild(d);
      });
    }

    scrollToThumbnail(index) {
      const t = this.thumbnails[index];
      if (!t) return;
      const c = t.parentElement;
      if (!c) return;
      c.scrollTo({ left: t.offsetLeft - c.offsetWidth / 2 + t.offsetWidth / 2, behavior: "smooth" });
    }

    handleVideoAutoplay(index) {
      this.mainImages.forEach(img => {
        const v = img.querySelector("video");
        if (v) { v.pause(); v.currentTime = 0; }
      });
      const v = this.mainImages[index]?.querySelector("video");
      if (v && enableAutoplay) v.play().catch(() => {});
    }

    updateWithVariant(variant) {
      let match = -1;
      if (variant) {
        this.mainImages.forEach((img, i) => {
          if (
            (variant.mediaId   && img.dataset.mediaId   == variant.mediaId)   ||
            (variant.variantId && img.dataset.variantId == variant.variantId) ||
            (variant.imageUrl  && (img.src.includes(variant.imageUrl) ||
              img.dataset.src?.includes(variant.imageUrl)))
          ) match = i;
        });
      }
      this.changeImage(match >= 0 ? match : 0);
    }
  }

  // ── Registry ─────────────────────────────────────────────────────────────
  const galleryRegistry = [];

  function initAll() {
    document.querySelectorAll(".product-gallery").forEach(container => {
      if (!container.__galleryInstance) {
        const g = new ProductGallery(container);
        container.__galleryInstance = g;
        galleryRegistry.push(g);
      }
    });
  }

  document.addEventListener("variantImageSelected", e => {
    if (e.detail) galleryRegistry.forEach(g => g.updateWithVariant(e.detail));
  });
  document.addEventListener("variant:imageChanged", e => {
    if (e.detail) galleryRegistry.forEach(g => g.updateWithVariant(e.detail));
  });

  window.ProductGallery = { initAll, getAll: () => galleryRegistry };
  document.addEventListener("DOMContentLoaded", initAll);
})();
